// removed by extract-text-webpack-plugin
module.exports = {"infoText":"_1TUhDb4gi-R5CG9b5H-C50"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisYourTransactionFailed.scss
// module id = 1240
// module chunks = 0